import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import {
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
} from "availity-reactstrap-validation"

const sectionStyle = {
  border: "1px solid #e2e8f0", borderRadius: "8px", padding: "16px",
  marginBottom: "16px", background: "#fff"
}
const sectionTitle = (icon, title) => (
  <h6 style={{ color: "#6366f1", marginBottom: "14px", fontSize: "14px", display: "flex", alignItems: "center", gap: "8px" }}>
    <i className={`fas ${icon}`} style={{ fontSize: "13px" }}></i>{title}
  </h6>
)

const EditStaff = () => {
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [designations, setDesignations] = useState([])
  const [staff, setStaff] = useState({})
  const [dataLoaded, setDataLoaded] = useState(false)

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
      const response = await api.put("update-staff/" + id, values)
      if (response.data.success === true) setSubmitted(true)
    } catch (error) {
      // Handled by global interceptor
    }
    setLoading(false)
  }

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    try {
      const [staffResp, desig] = await Promise.all([
        api.get("staff/" + id),
        api.get("designations")
      ])
      const s = Array.isArray(staffResp.data.data) ? staffResp.data.data[0] : staffResp.data.data
      setStaff(s || {})
      setDesignations(Array.isArray(desig.data.data) ? desig.data.data : desig.data.data?.data || [])
    } catch (e) { console.error(e) }
    setDataLoaded(true)
  }

  if (!dataLoaded) return <div className="text-center p-5"><Spinner color="primary" /></div>

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}><h4>Edit Staff</h4></Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/staffs" className="dashBtn">
                <i className="fas fa-chevron-left"></i> <b>Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm style={{ position: "relative" }} className="form-horizontal"
            onValidSubmit={(e, v) => handleValidSubmit(e, v)}>

            {/* ── Designation ── */}
            <div style={sectionStyle}>
              {sectionTitle("fa-id-badge", "Designation")}
              <Row>
                <Col md={6}>
                  <div className="mb-3">
                    <AvField type="select" name="designation" label="Designation *" required value={String(staff.designation || "")}>
                      <option value="">Select Designation</option>
                      {designations.map((d, i) => (
                        <option key={i} value={d.id}>{d.designation}</option>
                      ))}
                    </AvField>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── Staff Information ── */}
            <div style={sectionStyle}>
              {sectionTitle("fa-user", "Staff Information")}
              <Row>
                <Col md={6}><div className="mb-3"><AvField name="staffName" label="Staff Name *" value={staff.staffName || ""} type="text" required /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="staffNumber" label="Staff Number" value={staff.staffNumber || ""} type="text" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="staffMobile" label="Mobile *" value={staff.staffMobile || ""} type="text" required /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="staffEmail" label="Email" value={staff.staffEmail || ""} type="email" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="salary" label="Salary" value={staff.salary || ""} type="number" /></div></Col>
                <Col md={6}><div className="mb-3"><AvField name="joiningDate" label="Joining Date" value={staff.joiningDate || ""} type="date" /></div></Col>
                <Col md={12}><div className="mb-3"><AvField name="staffAddress" label="Address" value={staff.staffAddress || ""} type="textarea" rows="2" /></div></Col>
              </Row>
            </div>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Staff is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button className="btn btn-primary w-md waves-effect waves-light" type="submit" disabled={loading}>
                  {loading ? (
                    <><Spinner animation="border" size="sm" /><span style={{ paddingLeft: "10px" }}>Updating...</span></>
                  ) : (
                    <span>Update Staff</span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditStaff
